import type { FC, ReactNode } from 'react'
import { useRef } from 'react'

import styled from '@emotion/styled'
import { m } from 'framer-motion'

import TableOfContentsBase, * as TableOfContents from '@segment/matcha/recipes/TableOfContents'

import useMaskOnScroll from '@segment/utils/useMaskOnScroll'

import { ListContextProvider } from './ListContext'

export interface ListProps {
  value?: string | number | null
  children: ReactNode
  className?: string
  onChange: (categoryId: string | number | null) => void
}

const List: FC<ListProps> = ({ value, children, className, onChange }) => {
  const scrollableContainerRef = useRef<HTMLDivElement>(null)

  const maskOnScroll = useMaskOnScroll({
    wrapper: scrollableContainerRef,
    axis: `vertical`,
    offset: `200px`,
  })

  return (
    <TableOfContentsBase className={className}>
      <TableOfContents.Title>Categories</TableOfContents.Title>
      <Mask style={{ WebkitMaskImage: maskOnScroll, maskImage: maskOnScroll }}>
        <TableOfContentsList ref={scrollableContainerRef}>
          <ListContextProvider active={value} setActive={onChange}>
            {children}
          </ListContextProvider>
        </TableOfContentsList>
      </Mask>
    </TableOfContentsBase>
  )
}

const TableOfContentsList = styled(TableOfContents.List)`
  overflow-y: auto;
  max-height: calc(100vh - 368px);
`
const Mask = styled(m.div)``

export default List
